
import type { FC } from 'react';
import { useMemo } from 'react';

import { playAudio, parsingAI } from '@/utils/audioPlay';
import { IObjString, IAIDragQuestionProps, IlistItem } from '@/utils/ctype';
import GroupTitle from '@/pages/Mock/components/GroupTitle';
import DragAI from '../../../components/DragAI';
import DropAI from '../../../components/DropAI';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';


const Container: FC<IAIDragQuestionProps> = function SentencePairingQuestions(props) {
  
  const { data, answerMap, groupId, answerAllText, keyIndex} = props;
  const { collect_option, list, type} = data;

  const {collectIdToContentMap, collectIdToTitleMap} = useMemo(() => {
    const collectIdToContentMap :IObjString = {};
    const collectIdToTitleMap :IObjString = {};
    collect_option.list.forEach((item) => {
      collectIdToTitleMap[item.id] = item.title;
      collectIdToContentMap[item.id] = item.content;
    }, {});
    return {collectIdToContentMap,collectIdToTitleMap };
  }, [collect_option.list]);

  const createAIType = (item: IlistItem, answer: string) => {
    const letter = collectIdToTitleMap[answer];
    if (item?.display_answer === letter) {
      return 'success';
    } else {
      return 'fail';
    }
  };

  return (
    <div className={style.box}>
      <div className={style.question}>
        {list.map((item, index: number) => {
          const key = `${groupId}_${type}_${item.id}`;
          const answer = answerMap[key] && answerMap[key][0];
          const resultType = createAIType(item, answer);
          return (
            <div className={style.questionItem} key={index}>
              <div className={style.questionText}><HtmlParser htmlString={item.title}></HtmlParser></div>
              <DropAI 
                data={item} 
                answerKey={`answerAllText.${item.number - 1}`} 
                dataKey={`question.question.${keyIndex}.list.${index}.display_answerHtml`} 
                type={resultType} 
                // answer={collectIdToContentMap[answer]} 
                answer={answerAllText[item.number - 1] || collectIdToContentMap[answer]} 
                playAudio={()=> {playAudio(item);}} 
                id={`question${item.number}`}
                parsingAI={() => {parsingAI(item);}} 
                blankClass={style.blank}/>
            </div>
          );
        })}
      </div>
      {
        data.title ? <GroupTitle title={data.title} /> : null
      }
      <div className={style.answer}>
        {
          collect_option.list.map((data, index: number) => {
            return (
              <DragAI data={data} optionClass={style.mt15} key={index}
                dataKey={`question.question.${keyIndex}.collect_option.list.${index}.content`} 
                titleKey={`$question.question.${keyIndex}.collect_option.list.${index}.title`} />
            );
          })
        }
      </div>
    </div>
  );
};

export default Container;